/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

export default function PlaybackEPG(backendAxiosInstance) {
  /**
   * @param {string} channelId
   */
  function createChannelPlaybackContext(channelId) {
    return backendAxiosInstance.post(
      '/blim/experience/v1/playback/EPG/context',
      { channelId },
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @typedef ChannelPlaybackParams
   * @type {object}
   * @property {string} channelId
   * @property {string} streamId
   */

  /**
   * @param {ChannelPlaybackParams} streamParams
   */
  function startChannelPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/EPG/start',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @typedef ContinueAndStopChannelPlaybackAdditionalParams
   * @type {object}
   * @property {number} programStart
   * @property {number} timelinePosition
   */

  /**
   * @typedef ContinueAndStopChannelPlaybackParams
   * @type {ChannelPlaybackParams & ContinueAndStopChannelPlaybackAdditionalParams}
   */

  /**
   * @param {ContinueAndStopChannelPlaybackParams} streamParams
   */
  function continueChannelPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/EPG/continue',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @param {ContinueAndStopChannelPlaybackParams} streamParams
   */
  function stopChannelPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/EPG/stop',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  return {
    createChannelPlaybackContext,
    startChannelPlayback,
    continueChannelPlayback,
    stopChannelPlayback,
  };
}
